module.exports = {
    data() {
        return {
            error: '',
        }
    },
    methods: {
        hideAreas() {
            $('#right-content .domain-info').hide();
        },
        reset() {
            this.error = '';
        },
        checkDomain: function () {
            this.hideAreas();
            $('#right-content .domain-info').show();
        },
        transferDomain: function () {
            let data = '';
            Swal.fire({
                title: 'Are you sure?',
                text: "These changes may take 48 hrs to initilize.",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#46c37b',
                cancelButtonColor: '#00ADD3',
                showLoaderOnConfirm: true,
                confirmButtonText: 'Start Transfer!',
                allowOutsideClick: false,
                preConfirm: () => {
                    return new Promise((resolve, reject) => {
                        this.axios.post('/api/domain/transfer', {
                            address: this.model.address,
                            tld: this.model.tld,
                            domainpw: this.model.domainpw
                        }).then(function (response) {
                            data = response.data;
                            resolve();
                        }).catch(function(error){
                            if(typeof error.response !== 'undefined') {
                                let data = error.response.data;
                                error.message = data.error;
                            }
                            data = {
                                type: 'error',
                                heading: 'Error',
                                message: error.message
                            };
                            resolve();
                        });
                    })
                }
            }).then(function() { myAlert(data) });
        },
        editNS: function () {
            this.hideAreas();
            this.axios.post('/api/domain/editNS', {
                registrar_id: this.model.registrar_id,
                domain: this.model.address,
                tld: this.model.tld
            }).then((response) => {
                let data = response.data;
                if (typeof data.error !== 'undefined') {
                    this.error = data.error;
                    return;
                }
                this.$eventHub.$emit('updateNameservers', this.id, data);
                // this.nameserver
            }).catch((errors) => {

            });
        },
        updateNS2: function () {
            let vm = this;
            let data = '';
            Swal.fire({
                title: 'Are you sure?',
                text: "These changes may take 48 hrs to complete.",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#46c37b',
                cancelButtonColor: '#00ADD3',
                showLoaderOnConfirm: true,
                confirmButtonText: 'Update Nameservers!',
                allowOutsideClick: false,
                preConfirm: function() {
                    return new Promise(function(resolve, reject) {
                        vm.axios.post('/domain/updateNS', {
                            address: $('#right-content input[name="address"]').val(),
                            tld: $('#right-content select[name="tld"]').val(),
                            nameservers: $('#updateNS input').serialize()
                        }).then(function (response) {
                            data = response.data;
                            resolve();
                        });
                    })
                }
            }).then(function() { myAlert(data) });
        },

        editDomain: function () {
            $('#localRegister').addClass('hide');
            let id = $('#right-content input[name=public_id]').val();
            this.axios.get('/domain/modify/' + id).then(function (response) {
                let data = response.data;
                if (typeof window.formData !== 'undefined') {
                    window.formData = jQuery.extend(formData, data.formData);
                } else { // Fallback
                    window.formData = data.formData;
                }
                $('#right-content .domain-info').html(data.html);
            }).catch(function(response) { vueAjaxFail(response) });
        },
        postDomainContacts: function () {
            let vm = this;
            let data = '';
            Swal.fire({
                title: 'Are you sure?',
                text: "These changes may take 4 - 24 hrs to propagate.",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#46c37b',
                cancelButtonColor: '#00ADD3',
                showLoaderOnConfirm: true,
                confirmButtonText: 'Update Details!',
                allowOutsideClick: false,
                preConfirm: function() {
                    return new Promise(function(resolve, reject) {
                        let body = {
                            address: $('#right-content input[name="address"]').val(),
                            tld: $('#right-content select[name="tld"]').val(),
                            body: $('.domain-info input, .domain-info select').serialize()
                        };
                        vm.axios.post('/domain/modify', body).then(function (response) {
                            data = response.data;
                            resolve();
                        }).catch(function (response) {
                            data = response.data;
                            resolve();
                        });
                    })
                }
            }).then(function() { myAlert(data) });
        },
        renewDomain: function () {
            let data = '';
            Swal.fire({
                title: 'Are you sure?',
                text: "You account will be charged for this transaction.",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#46c37b',
                cancelButtonColor: '#00ADD3',
                showLoaderOnConfirm: true,
                confirmButtonText: 'Renew Domain!',
                allowOutsideClick: false,
                preConfirm: () => {
                    return new Promise((resolve, reject) => {
                        this.axios.post('/api/domain/renew', {
                            registrar_id: this.model.registrar_id,
                            domain: this.model.address,
                            tld: this.model.tld
                        }).then(function (response) {
                            data = response.data;
                            if (typeof data['success'] !== 'undefined') {
                                data['success'] = 'Domain successfully renewed. It may take a few minutes to reflect this change in the domain details.';
                            }
                            resolve();
                        });
                    })
                }
            }).then(function() { myAlert(data) });
        }
    }
};